import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";


// ** Fetch Users
export const fetchStylesThunk = createAsyncThunk(
    "fetchStyles",
    async (params,config) => {
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL_LOCAL}/api/styles/fetchAll`,
            params
        );

        return response.data;
    }
);
export const createStylesThunk = createAsyncThunk(
    "createInspirations",
    async (data) => {

        const response = await axios.post(
            `${process.env.REACT_APP_API_URL_LOCAL}/api/styles/create`,
            data
        );

        return response.data;
    }
);


export const AdminCreateStylesThunk = createAsyncThunk(
  "adminCreateStyles",
  async (data) => {

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL_LOCAL}/api/styles/admin/create`,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return response.data;
  }
);

// Update Styles
export const updateStylesThunk = createAsyncThunk(
    "updateTattoo",
    async ({ id, values }, { rejectWithValue }) => {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_API_URL_LOCAL}/api/styles/update/${id}`,
          values
        );
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || "Error updating tattoo");
      }
    }
  );

// delete Style
export const deleteStyleThunk = createAsyncThunk(
    "deleteStyle",
    async ({ id }, { rejectWithValue }) => {
      try {
        const response = await axios.delete(
          `${process.env.REACT_APP_API_URL_LOCAL}/api/styles/delete/${id}`
        );
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || "Error deleting Style");
      }
    }
  );

// update order for shuffle data
export const updateStylesPositionThunk = createAsyncThunk(
    "updateStylesPosition",
    async (id, { rejectWithValue }) => {
      try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL_LOCAL}/api/styles/shuffleData`, {id:id.order} );
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    }
  );

  export const sortStylesThunk=createAsyncThunk(
    "sortStyles",
    async ({ id,isSorted }, { rejectWithValue }) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL_LOCAL}/api/styles/sort`,
          { id,isSorted }  // Ensuring correct API parameter
        );
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || "Error updating order");
      }
    }
  )

export const styleSlice = createSlice({
    name: "style",
    initialState: {
        styles: "",
        total: 0,
        limit: 10,
        page: 1,
        pageCount:0,
        isLoading: true,
    },
    reducers: {
        changeLimit: (state, action) => {
            state.limit = action.payload;
        },
        changePage: (state, action) => {
            state.page = action.payload;
        },
        updateOrder: (state, action) => {
            state.styles = action.payload; // Update state immediately on drag
          }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchStylesThunk.fulfilled, (state, action) => {
            state.styles=action?.payload?.data?.styles
            state.total=action?.payload?.data?.totalCount
            state.page=action?.payload?.data?.currentPage
            state.pageCount=action?.payload?.data?.totalPages
        })

    },
});

export const { changeLimit, changePage,updateOrder } = styleSlice.actions;
export default styleSlice.reducer;
